module.exports = __webpack_public_path__ + "img/EnergyWeapons.5e634655.png";